"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.ON_REMOVE_FROM_FUTURE = exports.PriorityQueue = void 0;
var analytics_core_1 = require("@segment/analytics-core");
Object.defineProperty(exports, "PriorityQueue", { enumerable: true, get: function () { return analytics_core_1.PriorityQueue; } });
Object.defineProperty(exports, "ON_REMOVE_FROM_FUTURE", { enumerable: true, get: function () { return analytics_core_1.ON_REMOVE_FROM_FUTURE; } });
//# sourceMappingURL=index.js.map